/**
 * @file CompletePickDialog.tsx
 * @description Подтверждение проведения сборки (phase19.14, экран B шага 0).
 *
 * Проведение необратимо: списывается остаток и двигается заказ, поэтому
 * последствия перечислены до кнопки, а не в тосте после.
 */

import { Alert } from "../../ui/alert";
import { Button } from "../../ui/button";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../../ui/dialog";

interface Props {
  taskNumber: string;
  orderNumber: string;
  itemsCount: number;
  saving: boolean;
  /** Ошибка сервера — например 422 `picking_incomplete` или нехватка остатка. */
  error: string | null;
  onConfirm: () => void;
  onClose: () => void;
}

export function CompletePickDialog({
  taskNumber,
  orderNumber,
  itemsCount,
  saving,
  error,
  onConfirm,
  onClose,
}: Props) {
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent fullScreen className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Провести сборку {taskNumber}?</DialogTitle>
        </DialogHeader>

        <div className="flex flex-col gap-3 overflow-y-auto text-sm">
          <p>
            Заказ <span className="font-mono">{orderNumber}</span>, позиций:{" "}
            {itemsCount}.
          </p>
          <ul className="flex list-disc flex-col gap-1 pl-5 text-on-surface-variant">
            <li>После проведения состав изменить нельзя.</li>
            <li>Товар будет списан со склада.</li>
            <li>Заказ перейдёт в «Собран».</li>
          </ul>
          {error ? <Alert severity="error">{error}</Alert> : null}
        </div>

        <DialogFooter>
          <Button variant="ghost" className="min-h-12" onClick={onClose} disabled={saving}>
            Отмена
          </Button>
          <Button className="min-h-12" onClick={onConfirm} disabled={saving}>
            {saving ? "Проводим…" : "Провести сборку"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
